<div class="container">
  <h1>Siteinställningar</h1>

  <app-site-form [site]="site"></app-site-form>
</div>
